import { LockClosedIcon } from "@radix-ui/react-icons";
import { MessageResponse } from "client/openapi";
import { useContext } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";
import { privateNote } from "./privacy";

/**
 * A lock before a Communication row's subject when its newest message is
 * kept to some admins (their personal addresses'), saying who sees it.
 */
export default function PrivateMark({ message }: { message: MessageResponse }) {
  const { account } = useContext(OrgRolesAndAccountContext);
  const note = privateNote(message, account?.reference_id);
  if (!note) return null;
  return (
    <span title={note} className="mr-1 inline-flex align-[-2px] text-gray-600">
      <LockClosedIcon aria-label={note} role="img" />
    </span>
  );
}
